import { render, staticRenderFns } from "./SfRadio.vue?vue&type=template&id=5774c748"
import script from "./SfRadio.vue?vue&type=script&lang=js"
export * from "./SfRadio.vue?vue&type=script&lang=js"
import style0 from "./SfRadio.vue?vue&type=style&index=0&id=5774c748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports